import React, { FC } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { ITrailerShipmentFragment } from 'apps/marketplace/pages/shippers/components/ShipperTrailers/graphql/TrailerShipmentFragment'
import EmptyInfo from './EmptyInfo'

interface IStopTypeProps {
  currentStop: ITrailerShipmentFragment['stops'][number] | undefined
  currentStopName: string
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    height: '100%',
    gap: 3,
  },
})

const StopType: FC<IStopTypeProps> = ({ currentStop, currentStopName }) => {
  const styles = useStyles()

  if (currentStop) {
    return (
      <div>
        <Typography variant='body1' className={styles.root}>
          {currentStopName}
        </Typography>
      </div>
    )
  }

  return <EmptyInfo />
}

export default StopType
